import * as React from 'react';
import TextEditor from 'sma.common/texteditor';
import { ContentModal } from 'sma.common/components/modals';
import { v4 as uuidv4 } from 'uuid';

export default class HtmlTextarea extends React.Component {

	id;

	static escapeScript(value) {
		return value
			.replace(/<script/g, '<!--<script')
			.replace(/<\/script>/g, '</script>-->');
	}

	static unescapeScript(value) {
		return value
			.replace(/<!--<script/g, '<script')
			.replace(/<\/script>-->/g, '</script>');
	}

	constructor(props) {
		super(props);

		this.id = uuidv4();
		this.state = {
			value: props.value,
			name: props.name,
			showEditorButton: false
		};
		this.openHtmlEditor = this.openHtmlEditor.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.showFocus = this.showFocus.bind(this);
		this.hideFocus = this.hideFocus.bind(this);
	}

	openHtmlEditor() {
		const targetTextArea = document.getElementById(this.id);
		const textarea = document.createElement('textarea');
		document.getElementsByTagName('body')[0].appendChild(textarea);

		const dialog = new ContentModal(
			textarea,
			{
				title: gettext('Visual Editor'),
				destroyOnClose: true,
				buttons: [{
					label: gettext('OK'),
					cls: 'button-default',
					handler: () => {
						const event = {
							target: {
								// eslint-disable-next-line no-use-before-define
								value: editor.getContent()
							}
						};
						this.handleInputChange(event);
						targetTextArea.focus();
						dialog.hide();
					}
				}]
			}
		);

		// This needs to be defined after the dialog (ask Nathan why)
		const editor = new TextEditor({
			textarea: textarea,
			piping: ['all']
		});

		editor.setContent(this.state.value.get());
		dialog.show();
	}

	handleInputChange(event) {
		const valueObject = this.state.value;
		valueObject.set(HtmlTextarea.escapeScript(event.target.value));
		valueObject.changed(valueObject.get());
		this.setState({
			value: valueObject
		});

		const returnEvent = {
			target: {
				name: this.state.name,
				value: valueObject
			}
		};
		this.props.change(returnEvent);
	}

	showFocus() {
		this.setState({
			showEditorButton: true
		});
	}

	hideFocus() {
		this.setState({
			showEditorButton: false
		});
	}

	render() {
		return (
			<React.Fragment>
				<label id={this.id} htmlFor={this.id}>
					<strong>
						{this.props.label}
					</strong>
				</label>
				<textarea
					className="form-control text"
					id={this.id}
					value={HtmlTextarea.unescapeScript(this.state.value.get())}
					onChange={this.handleInputChange}
					onFocus={this.showFocus}
					onBlur={this.hideFocus}
				/>
				{
					this.state.showEditorButton
					&& (
						// This has to be onMouseDown to be triggered before the textare onBlur
						<a className="edit-html"
							onMouseDown={this.openHtmlEditor}
						>
							Open Visual Editor
						</a>
					)
				}
			</React.Fragment>
		);
	}
}
